import React from "react";
import {Form, Input, Radio, Switch, InputNumber, Select, Tooltip} from 'antd';
import NHFormItem from '../../common/NHFormItem';
import NHFetch from '../../../utils/NHFetch';
import NHSelect from '../../common/NHSelect/index'
import { hasAuth } from "../../../utils/NHCore";
const FormItem = Form.Item;

const baseUrlPath = "/fwwgl/shwpgl";

/**
 * 生活物品编辑表单
 * @date 2018-03-02 14:00
 * Version: 1.0
 */
class EditInitForm extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            statusList:this.props.statusList,
            flagsList:this.props.flagsList,
            dqnd:undefined,
            Sfxm:undefined,
            check:true,//必须购买开关,用来控制数量值
        }
    }

    componentWillMount(){
        this.getDqnd();
        this.getSfxm();
    }

    //是否必须购买开关回调事件
    switchChange = (checked,e) =>{
        this.setState({check:checked});
    }
    
    //获取当前年度
    getDqnd = () => {
        NHFetch(baseUrlPath + '/getDqnd' , 'GET' , undefined).then(res => {
            if (res) {
                this.setState({
                    dqnd:res.data,
                });
            }
        });
    }
    //获取收费项目
    getSfxm = () => {
        NHFetch(baseUrlPath + '/getSfxmZdy' , 'GET' , undefined).then(res => {
            if (res) {
                this.setState({
                    Sfxm:res.data,
                });
            }
        });
    }

    render() {

        const {getFieldDecorator,setFieldsValue} = this.props.form;
        const initData = this.props.initFormData;
        const {Sfxm,check} = this.state;
        let Sfxms = [];
        if(Sfxm) {
            Sfxms = Sfxm.map((item,index) => <Select.Option key={index} value={item.VALUE}>{item.LABEL}</Select.Option>);
        }
        return (
            <div>
                <Form layout="horizontal">
                    <div style={{display:'none'}} >
                        <NHFormItem label="年度" id={"nd"}
                                    form={this.props.form}  initialValue={this.state.dqnd}>
                                <Input  />
                        </NHFormItem>
                    </div>
                    <NHFormItem id={"wpmc"} required={true} label={"物品名称"}
                                form={this.props.form} initialValue={initData.WPMC}>
                                <Input  placeholder="请输入物品名称"/>
                    </NHFormItem>
                    <NHFormItem id={"wpgg"} label={"物品规格"}
                                form={this.props.form} initialValue={initData.WPGG}>
                                <Input  placeholder="请输入物品规格"/>
                    </NHFormItem>
                    <NHFormItem id={"zlyq"} label={"质量要求"} required={true}
                                form={this.props.form} initialValue={initData.ZLYQ}>
                                <Input  placeholder="请输入质量要求"/>
                    </NHFormItem>
                    <NHFormItem id={"wpdj"} label={"物品单价"} required={true}
                                form={this.props.form} initialValue={initData.WPDJ}>
                                <InputNumber
                                min={0}
                                step={0.1}
                                />
                    </NHFormItem>
                    <NHFormItem id={"sfbxxg"} label={"是否必须选购"} required={true} valuePropName={'checked'}
                                form={this.props.form} initialValue={initData.SFBXXG?(initData.SFM=='1'?true:false):true}>
                                <Switch checkedChildren={this.state.flagsList[1]} unCheckedChildren={this.state.flagsList[0]} onChange={this.switchChange}/>
                    </NHFormItem>
                    <NHFormItem id={"zdgml"} label={"个人最大购买量"} required={true}
                                form={this.props.form} initialValue={initData.ZDGML}>
                                <InputNumber
                                min={ !check ? 0:1}
                                step={1}
                                />
                    </NHFormItem>
                    <NHFormItem id={"pxh"} label={"排序号"} required={true}
                                form={this.props.form} initialValue={initData.PXH}>
                                <InputNumber
                                min={0} max={999999}
                                step={1}
                                />
                    </NHFormItem>
                    <NHFormItem id={"wpzt"} label={"物品状态"} required={true} valuePropName={'checked'}
                                form={this.props.form} initialValue={initData.WPZT?(initData.ZTM=='1'?true:false):true}>
                                <Switch checkedChildren={this.state.statusList[1]} unCheckedChildren={this.state.statusList[0]}/>
                    </NHFormItem>
                   <div style={{ position: 'relative'} }>
                    <NHFormItem id={"sfxmid"} label={"关联收费项目"}
                                form={this.props.form} initialValue={initData.SFXMID}> 
                                <Select placeholder= '请选择...' style={{width:'100%'}}>
                                    <Select.Option value=''>请选择...</Select.Option>
                                    {Sfxms}
                                </Select> 
                    </NHFormItem>
                    <Tooltip 
                            title={<div>作用：选择“关联收费项目”后学生选购产生的费用会自动计入到对应的收费项目中<br></br>注意：所选的“关联收费项目”最好是没有固定收费金额的收费项</div> } >   
                            <img style={{position: 'absolute', left: '71%',top: '12px'}} src={require('../../../styles/images/wenhao18.png')}></img> 
                    </Tooltip>
                    </div>  
                </Form>
            </div>
        );
    }
}

const EditForm = Form.create()(EditInitForm);

export default EditForm;


// WEBPACK FOOTER //
// ./components/fwwgl/shwpgl/EditForm.js